









































import { Mutations } from "@/store/mutations";
import Vue from "vue";

/**
 * Show and modify values in the current Show model
 */
export default Vue.extend({
  name: "StuntSheetModal",
  computed: {
    title: {
      get(): string {
        const stuntSheet = this.$store.getters.getSelectedStuntSheet;
        return stuntSheet.title;
      },
      set(title: string): void {
        this.$store.commit(Mutations.SET_STUNT_SHEET_TITLE, title);
      },
    },

    beats: {
      get(): number {
        const stuntSheet = this.$store.getters.getSelectedStuntSheet;
        return stuntSheet.beats;
      },
      set(beats: number): void {
        this.$store.commit(Mutations.SET_STUNT_SHEET_BEATS, beats);
      },
    },

    canDeleteSS(): boolean {
      return this.$store.state.show.stuntSheets.length > 1;
    },
  },
  methods: {
    deleteSS(): void {
      this.$store.commit(Mutations.DELETE_STUNT_SHEET);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$parent as any).close();
    },
  },
});
